import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../providers/appProvider';
import cl from "./View.module.css";
import Plus from "../../../../assets/Icon/Plus"; 
import Modal from '../../../UI/Modal/Modal';
import Pen from "../../../../assets/Icon/Pen";
import Select from "react-select";
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import { selectStyle } from './selectStyle';
import { Link } from 'react-router-dom'; 
import Sale from '../Sale/Sale';

const initEditPrice = (Booking) => {
    console.log(Booking)
    return {
        id: Booking.id,
        booking_id: Booking.booking_id,
        seller_id: Booking.seller_id,
        status_id: Booking.status_id,
        user_id: Booking.user_id,
        sender_country_id: Booking.sender_country_id,
        sender_city_id: Booking.sender_city_id,
        reciever_country_id: Booking.reciever_country_id,
        reciever_city_id: Booking.reciever_city_id,
        reciever_country: Booking.reciever_country,
        sender_country: Booking.sender_country,
        type_id: Booking.type_id,
        created_at: Booking.created_at || '',
        driver_id: Booking.driver_id, 
        driver_name: Booking.driver_name,
        driver_surname: Booking.driver_surname,
        driver_phone: Booking.driver_phone,
        driver_car: Booking.driver_car,
        updated_at: new Date().toLocaleString(),
        message: Booking.message || '',
        description: Booking.description || '',
        marine_subtype_id: Booking.marine_subtype_id,
        icoterm_id: Booking.icoterm_id,
        land_subtype_id: Booking.land_subtype_id,
        railway_subtype_id: Booking.railway_subtype_id,
        marine_line_id: Booking.marine_line_id,
        period_start_at: Booking.period_start_at || '',
        period_end_at: Booking.period_end_at || '',
        issued_price: Booking.issued_price || 0,
        custom_id: Booking.custom_id || 0,
        client: Booking.client || {
            firstname: '',
            lastname: '',
            email: '',
            mobile: ''
        }
    }
}
const BookingViewModal = ({ BookingService, BookingDetailsService, defaultBooking }) => {
    const initialTypeOptions = [
        { value: 0, label: ' ' },
        { value: 1, label: 'საზღვაო' },
        { value: 2, label: 'სახმელეთო' },
        { value: 3, label: 'სარკინიგზო' },
        { value: 4, label: 'საჰაერო' },
      ];

    const marineSubtype = [
        { value: 0, label: 'FCL' },
        { value: 1, label: 'LCL' },
        { value: 2, label: 'Oversized' },
    ];
    
    const landSubtype = [
        { value: 0, label: 'FTL' },
        { value: 1, label: 'LTL' },
        { value: 2, label: 'FCL' },
        { value: 3, label: 'Oversized' },
    ];

    const railwaySubtype = [
        { value: 0, label: 'FCL' },
        { value: 1, label: 'LCL' },
        { value: 2, label: 'Wagon' },
        { value: 3, label: 'Cistern' },
        { value: 4, label: 'Oversized' },
    ];

    const incotermTypes = [
        { value: 0, label: 'FOB' },
        { value: 1, label: 'FCA' },
        { value: 2, label: 'ExW' },
        { value: 3, label: 'DAP' },
        { value: 4, label: 'CIF' },
    ];

    const customsTypeOptions = [
        //{ value: 0, label: ' ' },
        { value: 1, label: 'იმპორტი' },
        { value: 2, label: 'ექსპორტი' },
        { value: 3, label: 'ტრანზიტი' },
        { value: 4, label: 'რეექსპორტი' },
    ];

    const statusTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'გაუქმებული' },
        { value: 2, label: 'გზაში' },
        { value: 3, label: 'დასრულებული' },
        { value: 4, label: 'მიმდინარე' },
    ];


    const { appState } = useContext(AppContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [tmpStatus, setTmpStatus] = useState(0);
    const [newBooking, setNewBooking] = useState(initEditPrice(defaultBooking));
    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);
    const [validates, setValidates] = useState({});
    const [textValue, setTextValue] = useState(newBooking.message || '');
    const [salesData, setSalesData] = useState([]);
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const agents = appState.agents.map((agent) => ({ value: agent.id, label: agent.name }));

      useEffect(() => {
          if (defaultBooking) {
              setNewBooking(initEditPrice(defaultBooking));
              setTextValue(defaultBooking.message || '');
              loadSalesData(defaultBooking.id);
          }
      }, [defaultBooking]);
  
      const loadSalesData = async (bookingId) => {
          try {
              const details = await BookingDetailsService.getByBookingId(bookingId);
              if(details != null) {
                  setSalesData(details.booking_details.map((detail, index) => ({
                      id: index + 1,
                      data: detail
                  })));
              }
          } catch (error) {
              console.error("Error loading sales data:", error);
          }
      };

    const openAdd = () => {
        setNewBooking(initEditPrice(defaultBooking))
        setIsModalOpen(true)
    }

    const openStatusChangeConfirmation = (selectedOption) => {
        setTmpStatus(selectedOption.value)
        setIsConfirmationOpen(true)
    }

    const closeStatusChangeConfirmation = () => {
        setIsConfirmationOpen(false)
    }

    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),
    };

    const readOnlyInputStyle = {
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        cursor: 'default',
        pointerEvents: 'none',
        color: '#1a202c',
    };

    console.log(newBooking)

    return(
        <div>
            <span className={cl.editBtn} onClick={() => openAdd()} >
                <Pen /> ნახვა
            </span>

            <Modal size="xl" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead}>
                    <h3><span className={cl.iconHead}><Pen /></span> ნახვა</h3>
                </div>

                <fieldset className={cl.formField}>
                    <legend>ჩატვირთვის ქვეყანა</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newBooking.sender_country_id}
                        childId={newBooking.sender_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub={newBooking.type_id == 2 ? "ქვეყანა" : "პორტი"}
                        disabled={true}
                        />

                </fieldset>

                <fieldset className={cl.formField}>
                    <legend>მიმღების ქვეყანა</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newBooking.reciever_country_id}
                        childId={newBooking.reciever_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub={newBooking.type_id == 2 ? "ქვეყანა" : "პორტი"}
                        disabled
                    />
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>საბაჟოს ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={customsTypeOptions}
                            value={customsTypeOptions.find(option => option.value === newBooking.custom_id)}
                            isDisabled
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>სტატუსი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={statusTypes}
                            value={statusTypes.find(option => option.value === newBooking.status_id)}
                            isDisabled
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>გადაზიდვის ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={typeOptions}
                            value={typeOptions.find(option => option.value === newBooking.type_id)}
                            isDisabled
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                {newBooking.type_id == 2 && (
                    <fieldset style={{ display: "flex", gap: '10px', flexDirection: 'column' }} className={cl.formField}>                        
                        <div style={{ display: "flex", gap: '10px' }}>
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${validates?.driver_id ? cl.error : ''}`}
                                    value={newBooking.driver_id || ''}
                                    isDisabled
                                    style={readOnlyInputStyle}
                                    placeholder='მძღოლის პ/ნ'
                                />
                            </div>
                            
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${validates?.driver_name ? cl.error : ''}`}
                                    value={newBooking.driver_name || ''}
                                    isDisabled
                                    placeholder="მძღოლის სახელი"
                                    style={readOnlyInputStyle}
                                />
                            </div>
                        </div>
                        
                        <div style={{ display: "flex", gap: '10px' }}>
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${validates?.driver_surname ? cl.error : ''}`}
                                    value={newBooking.driver_surname || ''}
                                    isDisabled
                                    placeholder="მძღოლის გვარი"
                                    style={readOnlyInputStyle}
                                />
                            </div>
                            
                            <div style={{ width: "50%" }}>
                                <input
                                    type="text"
                                    className={`${cl.input} ${validates?.driver_phone ? cl.error : ''}`}
                                    value={newBooking.driver_phone || ''}
                                    disabled
                                    placeholder="მძღოლის ტელეფონი"
                                    style={readOnlyInputStyle}
                                />
                            </div>
                        </div>
                        <div style={{ width: "80%" }}>
                            <input
                                type="text"
                                className={`${cl.input} ${validates?.driver_car ? cl.error : ''}`}
                                value={newBooking.driver_car || ''}
                                disabled
                                placeholder="სატრ.საშუალების ნომერი"
                                style={readOnlyInputStyle}
                            />
                        </div>
                    </fieldset>
                )}

                {newBooking.type_id === 1 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={marineSubtype}
                                value={marineSubtype.find(option => option.value === newBooking.marine_subtype_id)}
                                isDisabled
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                isDisabled
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newBooking.type_id == 2 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={landSubtype}
                                value={landSubtype.find(option => option.value === newBooking.land_subtype_id)}
                                isDisabled
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                isDisabled
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newBooking.type_id == 3 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={railwaySubtype}
                                value={railwaySubtype.find(option => option.value === newBooking.railway_subtype_id)}
                                isDisabled
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                isDisabled
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                )
                : (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newBooking.icoterm_id)}
                                isDisabled
                                placeholder="Incoterms"
                            />
                        </div>
                        <div style={{ width: "50%" }}></div>
                    </fieldset>
                )}

                {
                    newBooking.type_id == 2 ? 
                        <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                            <legend>აგენტი</legend>

                            <div style={{ width: "50%" }}>
                                <Select
                                    styles={validates && validates.marine_line_id ? { ...selectStyle, ...stylesError } : selectStyle}
                                    options={agents}
                                    value={agents.find(option => option.value === newBooking.marine_line_id)}
                                    isDisabled
                                    placeholder="აგენტი"
                                    isClearable={true}
                                />
                            </div>
                        </fieldset> 
                :
                        <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                            <legend>საზღვაო ხაზი</legend>

                            <div style={{ width: "50%" }}>
                                <Select
                                    styles={validates && validates.marine_line_id ? { ...selectStyle, ...stylesError } : selectStyle}
                                    options={marines}
                                    value={marines.find(option => option.value === newBooking.marine_line_id)}
                                    isDisabled
                                    placeholder="საზღვაო ხაზი"
                                    isClearable={true}
                                />
                            </div>
                        </fieldset>
                }

                <fieldset style={{ display: "flex", gap: '10px', flexDirection: 'column' }} className={cl.formField}>                        
                    <label>გაცემული ფასი</label>
                    <div style={{ width: "50%" }}>
                        <input
                            type="text"
                            className={`${cl.input} ${validates?.issued_price ? cl.error : ''}`}
                            value={newBooking.issued_price || 0}
                            isDisabled
                            placeholder="გაცემული ფასი"
                        />
                    </div>
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px'}}  className={cl.formField}>
                    <textarea
                        id="message"
                        value={defaultBooking.message}
                        rows={4}
                        cols={100}
                        disabled
                        style={{selectStyle, border: '1px solid grey', borderRadius: '6px', padding: '8px'}}
                        placeholder="კომენტარი"
                    />
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px'}}  className={cl.formField}>
                    <textarea
                        id="description"
                        value={defaultBooking.description}
                        rows={4}
                        cols={100}
                        disabled
                        style={{selectStyle, border: '1px solid grey', borderRadius: '6px', padding: '8px'}}
                        placeholder="Description"
                    />
                </fieldset>

                <h2 style={{textAlign: 'center'}}>SALE</h2>
                <div className="sales-list">
                    {salesData.map((sale) => (
                        <div key={sale.id} style={{marginBottom:"24px"}}>
                            <Sale 
                                key={sale.id}
                                id={sale.id}
                                onUpdate={() => {}}
                                saleData={sale.data}
                                isUpdate={true}
                                isView={true}
                                booking={newBooking}
                            />
                        </div>
                    ))}
                </div>

            </Modal>

        </div>
    )
}

export default BookingViewModal;